import React from "react";
import Header from "./components/Header";
import { Footer } from "./components/Footer";
import { Contactform } from "./components/Contactform";
import { Broadband, BroadbandFaqs } from "./components/Broadband";
import Slider from "react-slick";
import Banner01 from "./images/banner01.jpg";
import Banner02 from "./images/Banner02.jpg";
import Banner03 from "./images/Banner03.jpg";
import Banner04 from "./images/Banner04.jpg";
import Banner05 from "./images/Banner05.jpg";
import Banner06 from "./images/Banner06.jpg";
import BannerMobile01 from "./images/Banner01m.jpg";
import BannerMobile02 from "./images/Banner02m.jpg";
import BannerMobile03 from "./images/Banner03m.jpg";
import BannerMobile04 from "./images/Banner04m.jpg";
import BannerMobile05 from "./images/Banner05m.jpg";
import BannerMobile06 from "./images/Banner06m.jpg";

export const Broadbandplan = ({ match }) => {
  const slugData = match.params.slug;

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "ease-in-out",
    centerMode: true,
    centerPadding: "150px",
  };
  var settingsMobile = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "ease-in-out",
    centerMode: true,
    centerPadding: "30px",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 360,
        settings: {
          centerPadding: "12px",
        },
      },
    ],
  };

  return (
    <>
      <Header />
      <section
        id="banner"
        className="p-0 hbanner newbanner"
        data-aos="fade-left"
        data-aos-offset="200"
        data-aos-duration="600"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
      >
        <div
          style={{
            width: "100%",
            position: "relative",
            marginTop: "120px",
            padding: "0 10px",
            boxSizing: "border-box",
          }}
        >
          {/* Desktop Slider */}
          <div className="banner-desktop">
            <Slider {...settings}>
              {[Banner05, Banner03, Banner02, Banner04, Banner01, Banner06].map(
                (banner, index) => (
                  <div key={index} style={{ padding: "0 8px" }}>
                    <img
                      src={banner}
                      alt={`Banner ${index + 1}`}
                      loading={index === 0 ? "eager" : "lazy"}
                      decoding="async"
                      fetchPriority={index === 0 ? "high" : "auto"}
                      draggable={false}
                      style={{
                        width: "100%",
                        display: "block",
                        objectFit: "cover",
                        borderRadius: "20px",
                      }}
                    />
                  </div>
                ),
              )}
            </Slider>
          </div>

          {/* Mobile Slider */}
          <div className="banner-mobile">
            <Slider {...settingsMobile}>
              {[
                BannerMobile02,
                BannerMobile03,
                BannerMobile04,
                BannerMobile05,
                BannerMobile06,
                BannerMobile01,
              ].map((banner, index) => (
                <div key={index} style={{ padding: "0 8px" }}>
                  <img
                    src={banner}
                    alt={`Banner ${index + 1}`}
                    loading={index === 0 ? "eager" : "lazy"}
                    decoding="async"
                    fetchPriority={index === 0 ? "high" : "auto"}
                    draggable={false}
                    style={{
                      width: "100%",
                      display: "block",
                      objectFit: "cover",
                      borderRadius: "20px",
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <section id="Broadband" className="blckarrow">
        <div className="container">
          <div className="row">
            <div
              className="title"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="600"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              <span>Broadband Plans</span>
              <h3>Your need. Your choice.</h3>
            </div>
            <Broadband slugData={slugData} />
          </div>
        </div>
      </section>
      <BroadbandFaqs />
      {/* <Contactform /> */}
      <Footer />
    </>
  );
};
